export default "__VITE_ASSET__CvAr83Ng__"